
import {
  MenuOutlined,
  BankOutlined,
  TeamOutlined,
  CommentOutlined,
  PieChartOutlined,
  
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import React from "react";

export const MenuList: MenuProps["items"] = [
  {
    key: "/recruiter/home",
    icon: React.createElement(BankOutlined),
    label: "Dashboard",
  },

  {
    key: "/recruiter/jobs",
    icon: React.createElement(MenuOutlined ),
    
    label: "JobList",
  },
  {
    key: "/recruiter/candidates",
    icon: React.createElement(TeamOutlined),
    label: "Candidates",
  },
  {
    key: "/recruiter/message",
    icon: React.createElement(CommentOutlined),
    label: "Message",
  },
  {
    key: "/recruiter/activity",
    icon: React.createElement(PieChartOutlined),
    label: "Activity",
  },
];
